module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-regular-400-a57bcf76c178aee452db7a57b75509b6.woff";